import React from 'react';

import CurrentVersionReadOnlyReasonWrapper from 'app/developer-v3/components/CurrentVersionReadOnlyReasonWrapper';

import ActionApi from './ActionApi';

export default function ActionApiWrapper(props) {
  return (
    <CurrentVersionReadOnlyReasonWrapper Component={ActionApi} {...props} />
  );
}
